import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from '../../services/error.service';
import { FileService } from '../../services/file.service';
import { OrderService } from '../../services/order.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
	selector: 'app-select-print-label',
	templateUrl: './select-print-label-modal.html'
})

export class SelectPrintLabelModalComponent implements OnInit {
	public availableShippingLabels: any;
	public form: UntypedFormGroup;
	public selectedLabelIsDefault: boolean;

	constructor(private _orderService: OrderService,
				private _errorService: ErrorService,
				private _fileService: FileService,
				public dialogRef: MatDialogRef<SelectPrintLabelModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder,
				private _spinnerService: SpinnerService) {
	}

	closeModal() {
		this.dialogRef.close();
	}

	generateLabel() {
		this._spinnerService.startSpinner();
		this._orderService.getLabelByProcedureId(this.data.id, this.form.value.labelProcedureId, this.form.value.includePieces).subscribe((response: any) => {
				const file = new Blob([response], {type: 'application/pdf'});
				if ((window.navigator as any).msSaveOrOpenBlob) { // IE and Edge functionality
					(window.navigator as any).msSaveOrOpenBlob(file, 'Shipping Label-' + this.data.id + '.pdf');
				} else {
					this._fileService.openFileNewWindow(file);
				}
				this._spinnerService.stopSpinner();
				this.closeModal();
			},
			(error) => {
				this._spinnerService.stopSpinner();
				if (error.error instanceof Blob) {
					const file = new Blob([error.error], {type: error.error.type});
					const fr = new FileReader();
					fr.onload = (e: any) => {
						if (error.error.type === 'application/json') {
							error = JSON.parse(e.target.result);
						}
						this._errorService.error(error, 'getLabelByProcedureId Failed', 'modal');
					};
					fr.readAsText(file);
				} else {
					this._errorService.error(error, 'getLabelByProcedureId Failed', 'modal');
				}
				this.closeModal();
			});
	}

	getAvailableShippingLabels() {
		this._spinnerService.startSpinner();
		this._orderService.getAvailableShippingLabels()
			.subscribe(
				(response) => {
					this.availableShippingLabels = response;
					this._spinnerService.stopSpinner();
					if (response?.length > 0) {
						this.form.controls.labelProcedureId.setValue(response[0].procedureId, {onlySelf: true});
						this.form.updateValueAndValidity();
					}
				},
				(error) => {
					this._spinnerService.stopSpinner();
					this._errorService.error(error, 'getAvailableShippingLabels Failed', 'modal');
				});
	}

	ngOnInit() {
		this.form = this._formBuilder.group({
			labelProcedureId: [null, [Validators.required]],
			includePieces: [null, []]
		});
		this.form.get('labelProcedureId').valueChanges.subscribe((value) => {
			this.selectedLabelIsDefault = !!this.availableShippingLabels.find((label) => label.procedureId === value && label.isDefault);
		})
		this.getAvailableShippingLabels();
	}
}
